import { Button } from '@sketchnote/shared-components';
import React from 'react';

import { Member } from './manage-members';

export const RemoveUser = ({
  members,
  deleteMember,
  workspaceName,
  handleRemoveUserModalClose,
  handleRemoveUser,
}: {
  members: Member[];
  deleteMember: string;
  workspaceName: string;
  handleRemoveUser?: () => void;
  handleRemoveUserModalClose?: () => void;
}): JSX.Element => {
  return (
    <div>
      <p className="font-medium text-gray text-lg mb-16">Remove User</p>
      <p className="text-sm mb-16 text-gray-600">
        Are you sure?&nbsp;
        <span className="text-primary-500">
          {members.filter((item) => item.memberId === deleteMember)[0]?.firstname}
        </span>
        &nbsp;will no longer have editor access in the
        <span className="text-primary-500"> {workspaceName} </span> team
      </p>
      <div className="flex justify-center">
        <Button status="secondary" size="lg" className="mr-12" onClick={handleRemoveUserModalClose}>
          Cancel
        </Button>
        <Button status="primary" size="lg" onClick={handleRemoveUser}>
          Remove
        </Button>
      </div>
    </div>
  );
};
